import { normalizeSelectedContractIds } from '../../utils/contractDocuments'

const ContractDocumentPicker = ({
  documents = [],
  selectedIds = [],
  onChange,
  multiple = false,
  preloadedIds = [],
  isLoading = false,
  disabled = false,
  compact = false,
  label = 'Tipo de contrato *',
  error = null,
  hint = null,
}) => {
  const selectedSet = new Set(normalizeSelectedContractIds(selectedIds))
  const preloadedSet = new Set(normalizeSelectedContractIds(preloadedIds))

  const handleToggle = (documentId) => {
    if (disabled || isLoading) return

    const id = String(documentId)

    if (multiple) {
      const next = selectedSet.has(id)
        ? [...selectedSet].filter((item) => item !== id)
        : [...selectedSet, id]
      onChange(next)
      return
    }

    onChange(selectedSet.has(id) ? [] : [id])
  }

  return (
    <div>
      <label
        className={`form-label text-on-bg-primary mb-1 ${compact ? '' : 'fw-bold'}`}
        style={{ fontSize: compact ? '12px' : '13px' }}
      >
        {label}
      </label>

      {isLoading ? (
        <div className="d-flex align-items-center gap-2 py-2">
          <div className="spinner-border spinner-border-sm text-secondary" role="status" />
          <span style={{ fontSize: '13px', color: '#6b7280' }}>Cargando documentos…</span>
        </div>
      ) : documents.length === 0 ? (
        <p className="mb-0" style={{ fontSize: '13px', color: '#991b1b' }}>
          No hay documentos de contrato disponibles.
        </p>
      ) : (
        <div className="d-flex flex-wrap gap-2">
          {documents.map((document) => {
            const id = String(document.id)
            const isSelected = selectedSet.has(id)
            const isPreloaded = preloadedSet.has(id)

            return (
              <button
                key={document.id}
                type="button"
                disabled={disabled}
                onClick={() => handleToggle(document.id)}
                className={`d-flex border rounded text-start ${
                  compact
                    ? 'flex-row align-items-center px-2 py-1'
                    : 'flex-column align-items-start px-3 py-2'
                }`}
                style={{
                  minWidth: compact ? 'auto' : '140px',
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  background: isSelected ? '#f5f3ff' : '#ffffff',
                  borderColor: isSelected ? '#7c3aed' : '#e5e7eb',
                  color: isSelected ? '#5b21b6' : '#374151',
                  boxShadow: isSelected ? '0 0 0 1px #7c3aed' : 'none',
                  transition: 'border-color 0.15s, background 0.15s',
                  opacity: disabled ? 0.65 : 1,
                }}
              >
                <span style={{ fontSize: compact ? '12px' : '13px', fontWeight: 600 }}>
                  {document.name}
                  {!document.active ? ' (Inactivo)' : ''}
                </span>
                {!compact && (
                  <span style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>
                    {isPreloaded ? 'Configurado en empresa' : 'Disponible'}
                  </span>
                )}
              </button>
            )
          })}
        </div>
      )}

      {hint && (
        <p className="mb-0 mt-2" style={{ fontSize: '12px', color: '#6b7280' }}>
          {hint}
        </p>
      )}

      {error && (
        <span className="text-danger font-small d-block mt-1">{error}</span>
      )}
    </div>
  )
}

export default ContractDocumentPicker
